import React from 'react';
import { ColoredTextBoxContentModel } from 'src/api/models/ColoredTextBox';
import { ColoredTextBoxContainer } from './ColoredTextBox.styles';
import { formatElementFromHtmlAst } from 'src/functions/formatElement.htmlAst';

const ColoredTextBox = ({ backgroundColor, body }: ColoredTextBoxContentModel): JSX.Element => {
  const applicableTags = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p'];
  const bodyMarkup = body.childMarkdownRemark.htmlAst.children
    .filter((e) => e.tagName && applicableTags.includes(e.tagName))
    .map((e) => {
      if (e.tagName !== 'p') {
        // all H tags are converted to H5
        e.tagName = 'h5';
      }
      return e;
    });

  return (
    <ColoredTextBoxContainer backgroundColor={backgroundColor}>
      {bodyMarkup.map((child, index) =>
        formatElementFromHtmlAst({
          element: child,
          key: `${index}`,
          attachmentList: [],
          template: null,
        })
      )}
    </ColoredTextBoxContainer>
  );
};

export default ColoredTextBox;
